export default "__VITE_ASSET__BcPmlj8G__"